import styled, { css } from "styled-components";

import { useTranslate } from "@similarweb/i18n-provider";
import { Edit } from "@similarweb/icons";
import { colorsPalettes, setElevation } from "@similarweb/styles";
import { DotsLoader, Textfield } from "@similarweb/ui-components";

import { generateAutomationName } from "../../../helpers/generateAutomationName";
import { GaConnectTexts } from "../texts";

const editableCss = css`
    &:hover {
        ${setElevation("Z2")};
    }

    input {
        cursor: pointer;
    }

    input::placeholder {
        color: ${colorsPalettes.carbon[400]};
    }
`;

const StyledButton = styled.button`
    border: none;
    background: transparent;
    padding: 0;

    ${({ disabled }) => (disabled ? "cursor: not-allowed;" : editableCss)}
`;

export interface IPropertyNameFieldProps {
    isDisabled?: boolean;
    isLoading?: boolean;
    onClick?: () => void;
    propertyName: string;
}

export const PropertyNameField = ({ isDisabled, isLoading, onClick, propertyName }: IPropertyNameFieldProps) => {
    const { translate } = useTranslate();

    const customComponent = isLoading ? (
        <DotsLoader />
    ) : (
        <Edit
            size="sm"
            color={colorsPalettes.carbon[300]}
        />
    );

    return (
        <StyledButton
            onClick={onClick}
            disabled={isDisabled}
        >
            <Textfield
                dataAutomation={generateAutomationName("settings", ["section", "ga", "property-name"])}
                placeholder={translate(GaConnectTexts.gaSettingsConnectedPropertyInfo, { propertyName })}
                iconName="ga-icon"
                customComponent={isDisabled ? null : customComponent}
                disabled={isDisabled}
                readOnly
            />
        </StyledButton>
    );
};
